<template>
  <div class="main-wrapper">
    <div>
      <!-- <layout-header2></layout-header2> -->
      <layout-header></layout-header>
      <breadcrumb49></breadcrumb49>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar2></sidebar2>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="!showspinner">
              <div class="row ml-md-2">
                <div class="col-md-12" id="patient_container">
                  <!-- <h3 class="mb-4 mt-2">Receipts</h3> -->
                  <div class="appointment-tab">
                    <div class="tab-content">
                      <!-- Receipt Data -->
                      <div class="tab-pane show active" id="today-appointments">
                        <div class="card card-table mb-0" style="border: none;">
                          <div class="card-body">
                            <div class="row row-grid mb-2">
                              <div class="col-md-6 col-lg-4 col-xl-4">
                                <input type="text" v-model="search_doctor" class="form-control"
                                  placeholder="Search Doctor..." />
                              </div>
                            </div>
                            <div class="table-responsive">
                              <table class="table table-hover table-center mb-0">
                                <thead>
                                  <tr>
                                    <th style="background-color: #F8F8F8;" class="text-left">Receipt Number</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Date</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Doctor Name</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Patient Name</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, $index) in filteredReceipts" :key="item.id"
                                    v-show="setOpenReceipts($index)">
                                    <td class="text-left">
                                      <a>{{ item.name }}</a>
                                    </td>
                                    <td class="text-left">
                                      {{
                                        item.date ? formatDate(item.date) : "-"
                                      }}
                                    </td>
                                    <td class="text-left">
                                      {{ item.practitioner_full_name }}
                                    </td>
                                    <td class="text-left">
                                      {{ item.patient_full_name }}
                                    </td>
                                    <td class="text-left">
                                      {{ item.amount === 0 ? "-" : "₹" + item.amount }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <h5 v-if="open_receipt.length === 0 && !showspinner" class="No_data">
                                No Receipts Found
                              </h5>
                            </div>
                            <!-- pagination start -->
                            <div id="pagination" v-if="open_receipt.length > 10">
                              <ul class="pagination justify-content-center">

                                <!-- "Previous" Button -->
                                <li class="page-item" :class="receipt_current === 1 ? 'disabled' : ''">
                                  <a href="#" class="page-link" aria-label="Previous"
                                    @click.prevent="updateReceiptCurrent(receipt_current - 1)">
                                    Previous
                                  </a>
                                </li>

                                <!-- Pagination Links (Display 5 at a time) -->
                                <li v-for="page_index in receipt_paginate_total" :key="page_index.id" :class="[
                                  'page-item',
                                  receipt_current === page_index ? 'active' : ''
                                ]" v-if="page_index >= receipt_current - 2 && page_index <= receipt_current + 2">
                                  <a href="#" class="page-link" @click.prevent="updateReceiptCurrent(page_index)">
                                    {{ page_index }}
                                  </a>
                                </li>

                                <!-- "Next" Button -->
                                <li class="page-item" :class="receipt_current === receipt_paginate_total ? 'disabled' : ''
                                  ">
                                  <a href="#" class="page-link" aria-label="Next"
                                    @click.prevent="updateReceiptCurrent(receipt_current + 1)">
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <!-- pagination end -->
                          </div>
                        </div>
                      </div>
                      <!-- /recepit data -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "@/services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
const images = require.context("@/assets/img/patients");

export default {
  data() {
    return {
      // upcomingpatients: upcomingpatients,
      // todaypatients: todaypatients,
      config: config,
      open_receipt: [],
      showspinner: true,
      search_doctor: "",

      receipt_current: 1,
      receipt_paginate: 10,
      receipt_paginate_total: 0,

    };
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_receipt_data(),
      $(".progressresult").each(function () {
        const percentageToDegrees = (percentage) => {
          return (percentage / 100) * 360;
        };
        let value = $(this).attr("data-value");
        let left = $(this).find(".progress-left .progress-bar");
        let right = $(this).find(".progress-right .progress-bar");

        if (value > 0) {
          if (value <= 50) {
            right.css(
              "transform",
              "rotate(" + percentageToDegrees(value) + "deg)"
            );
          } else {
            right.css("transform", "rotate(180deg)");
            left.css(
              "transform",
              "rotate(" + percentageToDegrees(value - 50) + "deg)"
            );
          }
        }
      });
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
      user_type: (state) => state.user.user_type,
    }),
    filteredReceipts() {
      const searchTerm = this.search_doctor.toLowerCase().trim();
      return this.open_receipt.filter(item => {
        return item.name.toLowerCase().includes(searchTerm);
      });
    }
  },
  methods: {

    // pagination start
    setOpenReceipts(i) {
      if (this.receipt_current == 1) {
        return i < this.receipt_paginate;
      } else {
        return (
          i >= this.receipt_paginate * (this.receipt_current - 1) &&
          i < this.receipt_current * this.receipt_paginate
        );
      }
    },

    updateReceiptCurrent(i) {
      this.receipt_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },
    //pagination end

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      // const year = date.getFullYear();
      const year = date.getFullYear().toString().slice(-2);
      return `${day}-${month}-${year}`;
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    get_receipt_data() {
      let data = {
        hospital: "Ramsnehi Hospital-Bhilwara",
      };
      CommonApi.post_data("sahaj.hospital.get_hospital_receipts", data).then(
        (res) => {
          console.log(res);
          this.showspinner = false;
          if (res.status_code == 200) {
            this.open_receipt = res.data.opd_receipts;
            this.receipt_paginate_total = Math.ceil(
              this.open_receipt.length / this.receipt_paginate
            );
            console.log(res.data.opd_receipts)
          }
        }
      );
    },
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
  border-top: 1px solid #dddddd;
  /* Add an upper border */
}

th,
td {
  border: 1px solid #dddddd;
  /* You can adjust the border width and color as needed */
  padding: 8px;
  text-align: left;
}

th {
  background-color: #F8F8F8;
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/hospital/Receipts.vue